import { useState, useEffect } from "react";
import AddMaterialModal from "./AddMaterialModal";
import MaterialCategoryComponent from "./MaterialCategoryComponent";
import MaterialService from "src/Services/API/material.service";
import { toast } from "react-toastify";
import ArchiveMaterialCategoryModal from "./ArchiveMaterialCategoryModal";

const Active = () => {
  const [showAddMaterialModal, setShowAddMaterialModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [editingCategory, setEditingCategory] = useState(null);
  const [archiveTarget, setArchiveTarget] = useState(null);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  useEffect(() => {
    getMaterials();
  }, []);

  const handleAddMaterial = async (data) => {
    try {
      if (data?.id) {
        await MaterialService.update(data.id, {
          name: data.name,
          unit: data.unit,
          isMandatory: data.isMandatory,
        });
        toast.success("Material updated successfully");
      } else {
        await MaterialService.create({
          name: data.name,
          unit: data.unit,
          isMandatory: data.isMandatory,
        });
        toast.success("Material added successfully");
      }
      setShowAddMaterialModal(false);
      setEditingCategory(null);
      getMaterials();
    } catch (error) {
      toast.error(data?.id ? "Failed to update material" : "Failed to add material");
    }
  };

  const getMaterials = async () => {
    try {
      const response = await MaterialService.get();
      setCategories(response.data.filter((category) => category.isActive === true) || []);
    } catch (error) {
      toast.error("Failed to load material categories");
    }
  };
  const handleDeleteCategory = async (id) => {
    const target = categories.find((c) => c.id === id || c?.id === Number(id));
    if (!target) return;
    setArchiveTarget(target);
    setShowArchiveModal(true);
  };
  const handleEditCategory = async (id) => {
    const target = categories.find((c) => c.id === id || c?.id === Number(id));
    if (!target) return;
    setEditingCategory(target);
    setShowAddMaterialModal(true);
  };
  return (
    <div>
      {showAddMaterialModal && (
        <AddMaterialModal
          onCancelClicked={() => {
            setShowAddMaterialModal(false);
            setEditingCategory(null);
          }}
          onAddClicked={handleAddMaterial}
          initialData={editingCategory}
        />
      )}
      <div className="flex items-center justify-end">
        <div className="flex items-center gap-1 cursor-pointer mt-4" onClick={() => setShowAddMaterialModal(true)}>
          <span className="text-[17px] font-OpenSansRegular font-[600] text-subTitleColor">+ </span>
          <span className="text-[12px] font-OpenSansRegular font-[600] text-subTitleColor">Add Material</span>
        </div>
      </div>
      <div className="mt-4 flex flex-col gap-3">
        {categories.map((category) => (
          <MaterialCategoryComponent
            key={category.id || category.name}
            category={category}
            onDeleteCategory={handleDeleteCategory}
            onEditCategory={handleEditCategory}
          />
        ))}
        {categories.length === 0 && (
          <p className="text-[12px] font-OpenSansRegular text-subTitleColor">No material categories yet.</p>
        )}
      </div>
      {showArchiveModal && (
        <ArchiveMaterialCategoryModal
          name={archiveTarget?.name || ""}
          onCancel={() => {
            setShowArchiveModal(false);
            setArchiveTarget(null);
          }}
          onConfirm={async () => {
            if (!archiveTarget?.id) return;
            try {
              await MaterialService.update(archiveTarget.id, { isActive: false });
              toast.success("Material archived successfully");
              getMaterials();
            } catch (error) {
              toast.error("Failed to archive material");
            } finally {
              setShowArchiveModal(false);
              setArchiveTarget(null);
            }
          }}
        />
      )}
    </div>
  );
};

export default Active;
